const testIds = {
  preChatMessageActivityStarterPromptsCardAction: 'pre-chat message activity starter prompts card action',
  sendBoxContainer: 'send box container',
  sendBoxDropZone: 'send box drop zone',
  sendBoxMicrophoneButton: 'send box microphone button',
  sendBoxSendButton: 'send box send button',
  sendBoxSuggestedAction: 'send box suggested action',
  sendBoxTextBox: 'send box text area',
  sendBoxTelephoneKeypadButton1: `send box telephone keypad button 1`,
  sendBoxTelephoneKeypadButton2: `send box telephone keypad button 2`,
  sendBoxTelephoneKeypadButton3: `send box telephone keypad button 3`,
  sendBoxTelephoneKeypadButton4: `send box telephone keypad button 4`,
  sendBoxTelephoneKeypadButton5: `send box telephone keypad button 5`,
  sendBoxTelephoneKeypadButton6: `send box telephone keypad button 6`,
  sendBoxTelephoneKeypadButton7: `send box telephone keypad button 7`,
  sendBoxTelephoneKeypadButton8: `send box telephone keypad button 8`,
  sendBoxTelephoneKeypadButton9: `send box telephone keypad button 9`,
  sendBoxTelephoneKeypadButton0: `send box telephone keypad button 0`,
  sendBoxTelephoneKeypadButtonStar: `send box telephone keypad button star`,
  sendBoxTelephoneKeypadButtonPound: `send box telephone keypad button pound`,
  sendBoxTelephoneKeypadToolbarButton: 'send box telephone keypad toolbar button',
  sendBoxUploadButton: 'send box upload button'
};

export default testIds;
